import { render, staticRenderFns } from "./AthleteRatingsDashboard.vue?vue&type=template&id=44f3b274&scoped=true&"
import script from "./AthleteRatingsDashboard.vue?vue&type=script&lang=ts&"
export * from "./AthleteRatingsDashboard.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteRatingsDashboard.vue?vue&type=style&index=0&id=44f3b274&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44f3b274",
  null
  
)

export default component.exports